<!--
 * @Description: 商品详情页面组件
 * @Author: hai-27
 * @Date: 2020-02-16 20:20:26
 * @LastEditors: hai-27
 * @LastEditTime: 2020-03-07 21:59:26
 -->
<template>
  <div id="details">
    <!-- 头部 -->
    <!-- <div class="page-header">
      <div class="title">
       
      </div>
    </div> -->
    <!-- 头部END -->
      <div style="width:1890px;width:1500px;">
    <div style="display:flex;">
                <div style="width:300px;background:#015aac;">
                   <div style="padding:25px 20px 5px 20px;">
                    <img @click="gotoIndex()" src="../assets/imgs/sodeng.png" style="width:100%;"/>
                  </div>
                  <div style="display: flex;margin: 4px 3px;justify-content: space-between;padding: 4px 3px;box-sizing: border-box;background: #fff;">
                    <el-input size="small" style="width:100%;margin-right:3px;" v-model="keyword" placeholder="请输入内容"></el-input>
                    <div style="display:flex;">
                      <el-button size="small" style="" type="primary"  @click="searchKeyword">搜索</el-button>
                      <el-button size="small"  type="primary" style="border-radius: 0;background: #000;border: 1px solid #000">搜图</el-button>
                    </div>
                  </div>
                  <div style="display: flex;margin: 3px 3px;justify-content: space-between;box-sizing: border-box;background: #fff;margin-top: 3px;">
                    <div class="list_flex">

                      <div v-for="item in categoryList"
                          :key="item.category_id" :class="item_click==item.id ? 'aaa item' : 'item'  "  @click="switchTag(item.id)" >
                            <img :src="item.category_icon" style="width:45%;"/>
                            <div style="margin-top:6px;">{{item.name}}</div>
                          </div>
                    </div>
                  </div>
                </div>
                <div style="    flex:1;margin-left: 5px;width:825px;">
                  <div style="padding:10px;">  
                  <!-- <div @click="goback()">&lt; 返回</div> -->
                    <el-link @click="goback()">&lt; 返回
                  </el-link>
                  </div>
                      <!-- 主要内容 -->
    <div class="main" style="display:flex;background: #fff;">
      <!-- 左侧商品轮播图 -->
      <div class="block">
        <el-carousel height="415px" width="415px" :initial-index="ttttt" v-if="productPicture.length>0">
          <el-carousel-item v-for="item in productPicture" :key="item">
            <img style="height:415px;width:300415pxpx;" :src="item" />
          </el-carousel-item>
        </el-carousel>
        <!-- <div v-if="productPicture.length==1">
          <img
            style="height:560px;"
            :src="productPicture[0].product_picture"
            :alt="productPicture[0].intro"
          />
        </div> -->
      </div>
      <!-- 左侧商品轮播图END -->

      <!-- 右侧内容区 -->
      <div class="content" style="    display: flex; flex: 1;    flex-direction: column;">
        <!-- <h1 class="name" style="overflow: hidden;">{{productDetails.product_title}}</h1>
        <p class="intro">{{productDetails.product_name}}</p> -->
        <!-- <p class="store">{{productDetails.supplier_name}}</p> -->
        <!-- <div class="price"> -->
          <!-- <span>{{productDetails.product_selling_price}}元</span> -->
          <!-- <span
            v-show="productDetails.product_price != productDetails.product_selling_price"
            class="del"
          >{{productDetails.product_price}}元</span> -->
        <!-- </div> -->
        <!-- <div class="pro-list"> -->
          <!-- <span class="pro-name">{{productDetails.product_name}}</span>
          <span class="pro-price"> -->
            <!-- <span>{{productDetails.product_selling_price}}元</span> -->
            <!-- <span
              v-show="productDetails.product_price != productDetails.product_selling_price"
              class="pro-del"
            >{{productDetails.product_price}}元</span> -->
          <!-- </span> -->
          <!-- <p class="price-sum">售价 : {{productDetails.product_selling_price}}元</p> -->
        <!-- </div> -->
        <div style="width: 100%;display: flex;justify-content: space-between;font-size: 12px;color: gray;padding: 10px;box-sizing: border-box;border-bottom: 1px solid #eee;">
          <div style="font-size: 16px;font-weight: bold;">产品型号：{{productDetails.product_no}}</div>
          <div>已售：{{productDetails.product_buy}}笔</div>
        </div>
        <div style="margin-top:10px;display:flex;align-items: center;">
          <div style="width: 5px;height: 13px;background: rgb(1, 90, 172);"></div>
          <div style="font-size: 16px;padding-left:8px;">可选规格</div>
        </div>
        <div class="product_spec">
          <ul class="clearfix">
            
            <li style="font-size:13px;" @click="switchSpec(item.variable_id,item.variable_thumb)" 
            :style="item.variable_id == productDetails.variable_id ?'border:1px solid #ff6700;':''" 
            v-for="item in productDetails.spec" :key="item.product_id" >
            <!-- <el-image
              style="width: 42px; ;padding:5px;"
              :src="item.variable_thumb"
              :zoom-rate="1"
              :preview-src-list="srcList"
              :initial-index="1"
              fit="cover"
            /> -->
            <img :src="item.variable_thumb" style="width:42px;padding:5px;"/>
            <div style="    width: 100%;display:flex;    flex-direction: column;justify-content: center;align-items: flex-start;">
              <div style="font-size:14px;font-weight:bold;line-height:unset;height: 20px;">{{item.title}}</div>
              <div style="padding:0 5px;box-sizing:border-box;font-size:7px;display: flex;justify-content: space-between;width: 100%;">
                <div>可售:<span style="color:#a19b7b">{{item.product_num}}</span></div>
                <div style="text-decoration:line-through;font-size:16px;">原价:¥<span style="color:#a19b7b;">{{item.origin_price}}</span></div>
                <div>优惠价:<span style="color:red;font-size:16px;font-weight:bold;">{{item.product_price}}</span></div>
              </div>
            </div>
            </li>
          </ul>
        </div>
        <!-- 内容区底部按钮 -->
        <!-- <div class="button"> -->
          <!-- <el-button class="shop-cart" :disabled="dis" @click="addShoppingCart">收藏</el-button>
          <el-button class="like" @click="addCollect">喜欢</el-button> -->
        <!-- </div> -->
      </div>
      <!-- 右侧内容区END -->
      
    </div>

    <!-- 主要内容END -->
    <div class="content_a" style="display:flex;">

      <div class="title" style="flex:1;background:#fff;">
        <div style="padding: 10px 0;font-size: 14px;width:100%;text-align:center;    font-size: 18px;color: gray;">----产品详情----</div>
        <div style="width:100%;display:flex;    width: 100%;display: flex;flex-direction: column;align-items: center;">
        <img v-for="item in productDetailsPicture" :key="item.product_id" style="width:100%;width:790px;" :src="item.product_picture" />
        <img style="width:100%;width:790px;height:800px;" src="http://xcx.sodeng.cc/Public/fix/after_sale.jpg"/>
        </div>
      </div>
      <div style="width:200px;background:#fff;margin-left:5px;">
        <div style="    border-bottom: 1px solid #ccc;padding: 5px;margin: 5px;">相关推荐</div>
        <div style="    width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;">
          
          <div v-for="item in sameGoodsList" :key="item.product_id"  @click="gotodetail(item.product_id)" style="cursor: pointer;width:180px;height:210px;margin-top:5px;border: 1px solid #ccc;">
            <img style="width:100%;" :src="item.product_picture"/>
            <div style="display: flex;flex-direction: row;justify-content: space-between;margin: 0 10px;box-sizing: border-box;adding: 5px 0;">
                <div style="color:#ff6700;font-weight:bold;">{{item.product_selling_price}}</div>
                <div style="font-size:10px;">销量:{{item.product_buy}}</div>
            </div>
          </div>
          

        </div>
      </div>
    </div>
    


                </div>
    </div>
      </div>


  </div>

</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
         keyword:"",
      ttttt:0,
          item_click:'',
      page:0,
      call_id:0,
      categoryList:[],
      sameGoodsList:[],
      dis: false, // 控制“加入购物车按钮是否可用”
      productID: "", // 商品id
      productDetails: "", // 商品详细信息
      productDetailsPicture: "",//商品详情图片
      productPicture: [], // 商品图片
      productPictureOrigin:[],
    };
  },
  // 通过路由获取商品id
  activated() {
    if (this.$route.query.productID != undefined) {
      this.productID = this.$route.query.productID;
    }
  },
  created() {
    // 获取分类列表
    this.getCategory();
    this.page = this.$route.query.page;
  },
  watch: {
    // 监听商品id的变化，请求后端获取商品数据
    productID: function(val) {
      this.getDetails(val);
      this.getDetailsPicture(val);
    },
    // $route: function(val) {
    //   debugger
    //   if (val.path == "/goods/details") {
    //     if (val.query.productID != undefined) {
    //       var productID = val.query.productID;
    //       this.getDetails(productID);
    //     }
    //   }
    // }
  },
  methods: {
    searchKeyword(){
      this.$router.push({
        path: "/",
        query: {keyword:this.keyword }
      });
    },
     gotodetail(product_id)
    {
       this.$router.push({
        path: "/goods/details",
        query: { productID: product_id}
      });
      this.getDetails(product_id);
      this.getDetailsPicture(product_id);
    },
     gotoIndex(){
      this.$router.push({
        path: "/"
      });
    },
    switchTag(call_id){
      this.item_click = call_id
      this.$router.push({
        path: "/",
        query: {callid:call_id }
      });
    },
    goback(){
      this.$router.push({
        path: "/",
        query: {page:this.page }
      });
    },
    ...mapActions(["unshiftShoppingCart", "addShoppingCartNum"]),
    // 获取商品详细信息
    getDetails(val) {
      this.$axios
        .post("/api/resources/getdetails", {
          productID: val
        })
        .then(res => {
          this.productDetails = res.data.result.Product[0];
          this.getSame();
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    getSame(){
      var that = this;
      this.$axios
        .post("/api/resources/getsamegoods", {
          category_id:that.productDetails.category_id,
          supplier_id:that.productDetails.product_supplier_id
        })
        .then(res => {
          // const val = {
          //   category_id: 0,
          //   category_name: "全部"
          // };
          this.sameGoodsList  = res.data.result.Product;
         
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    // 向后端请求分类列表数据
    getCategory() {
      this.$axios
        .post("/api/resources/getcategory", {

        })
        .then(res => {
          this.categoryList  = res.data.result;
         
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    // 获取商品图片
    getDetailsPicture(val) {
      this.$axios
        .post("/api/resources/getdetailspicture", {
          productID: val
        })
        .then(res => {
          this.productPicture = res.data.result.ProductPicture;
          this.productPictureOrigin = res.data.result.ProductPicture;
          this.productDetailsPicture = res.data.result.ProductDetailPicture;
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    switchSpec(variable_id,variable_thumb){
      // var that = this;
      this.productPicture=[]
      this.productPicture[0] = variable_thumb;
      this.ttttt = 0;
      // var t = setTimeout(function(){
      //   that.productPicture = that.productPictureOrigin
      // },10000)
      // this.productDetails.product_selling_price = this.productDetails.spec[variable_id].product_price
      this.productDetails.variable_id = variable_id
    },
    // 加入购物车
    addShoppingCart() {
      // 判断是否登录,没有登录则显示登录组件
      if (!this.$store.getters.getUser) {
        // this.$store.dispatch("setShowLogin", true);
        return;
      }
      this.$axios
        .post("/api/user/shoppingCart/addShoppingCart", {
          user_id: this.$store.getters.getUser.user_id,
          product_id: this.productID
        })
        .then(res => {
          switch (res.data.code) {
            case "001":
              // 新加入购物车成功
              this.unshiftShoppingCart(res.data.shoppingCartData[0]);
              this.notifySucceed(res.data.msg);
              break;
            case "002":
              // 该商品已经在购物车，数量+1
              this.addShoppingCartNum(this.productID);
              this.notifySucceed(res.data.msg);
              break;
            case "003":
              // 商品数量达到限购数量
              this.dis = true;
              this.notifyError(res.data.msg);
              break;
            default:
              this.notifyError(res.data.msg);
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    addCollect() {
      // 判断是否登录,没有登录则显示登录组件
      if (!this.$store.getters.getUser) {
        // this.$store.dispatch("setShowLogin", true);
        return;
      }
      this.$axios
        .post("/api/user/collect/addCollect", {
          user_id: this.$store.getters.getUser.user_id,
          product_id: this.productID
        })
        .then(res => {
          if (res.data.code == "001") {
            // 添加收藏成功
            this.notifySucceed(res.data.msg);
          } else {
            // 添加收藏失败
            this.notifyError(res.data.msg);
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    }
  }
};
</script>
<style>
#details .product_spec{
  height: 480px;
  /* border: 1px solid #ccc; */
    overflow: auto;
}
#details .product_spec ul li{
  display: flex;
      overflow: hidden;
    margin-right: 12px;
    margin-top: 10px;
    line-height: 42px;
    height: 42px;
    position: relative;
    border: 1px solid #e0e0e0;
    list-style: none;
    cursor: pointer;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    float: left;
    width: 350px;
    font-size: 16px;
    text-align: center;
}
.product_spec_active{
  border:1px solid #ff6700;
  /* color:#ff6700; */
}

#details .content_a{
  margin-top: 5px;
  z-index: 4;
  /* background: #fff; */
  /* border-bottom: 1px solid #e0e0e0; */
  /* -webkit-box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.07);
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.07); */
}
#details .content_a .title {
  /* width: 1225px; */

  /* line-height: 64px; */
  font-size: 18px;
  font-weight: 400;
  color: #212121;
  margin: 0 auto;
}

.list_flex{
  align-content: flex-start;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  /* background: #; */
  margin-bottom: 50px;
}
.item{
  cursor: pointer;
  padding: 10px 0;
  width:33%;
  /* border:1px solid red; */
  height:65px;
  margin-top:14px;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  justify-content:center;
  align-items:center;
  align-content: flex-start
}
/*伪类 占位元素*/
.list_flex:after{
  content:' ';
  width:33%;
  height:0;
  display:block;
  flex: auto;
  width: 100%;
}

.el-button+.el-button{
  margin-left:2px;
}
.el-button--small, .el-button--small.is-round {
    padding: 4px 7px;
}



/* 头部CSS */
#details .page-header {
  height: 64px;
  margin-top: -20px;
  z-index: 4;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  /* -webkit-box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.07);
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.07); */
}
#details .page-header .title {
  width: 1225px;
  height: 64px;
  line-height: 64px;
  font-size: 18px;
  font-weight: 400;
  color: #212121;
  margin: 0 auto;
}
#details .page-header .title p {
  float: left;
}
#details .page-header .title .list {
  height: 64px;
  float: right;
}
#details .page-header .title .list li {
  float: left;
  margin-left: 20px;
}
#details .page-header .title .list li a {
  font-size: 14px;
  color: #616161;
}
#details .page-header .title .list li a:hover {
  font-size: 14px;
  color: #ff6700;
}
/* 头部CSS END */

/* 主要内容CSS */
#details .main {
  /* width: 1225px; */
  /* width: 825px; */
  height: 415px;
  padding-top: 10px;
  padding-left:10px;
  padding-bottom: 10px;
  margin: 0 auto;
}
#details .main .block {
  float: left;
  /* width: 560px; */
  width:415px;
  height: 415px;
}
#details .el-carousel .el-carousel__indicator .el-carousel__button {
  background-color: rgba(163, 163, 163, 0.8);
}
#details .main .content {
  float: left;
  margin-left: 10px;
  width: 520px;
}
#details .main .content .name {
  height: 30px;
  line-height: 30px;
  font-size: 24px;
  font-weight: normal;
  color: #212121;
}
#details .main .content .intro {
  color: #b0b0b0;
  padding-top: 10px;
}
#details .main .content .store {
  color: #ff6700;
  padding-top: 10px;
}
#details .main .content .price {
  display: block;
  font-size: 18px;
  color: #ff6700;
  border-bottom: 1px solid #e0e0e0;
  padding: 25px 0 25px;
}
#details .main .content .price .del {
  font-size: 14px;
  margin-left: 10px;
  color: #b0b0b0;
  text-decoration: line-through;
}
#details .main .content .pro-list {
  background: #f9f9fa;
  padding: 10px 20px;
  /* margin: 20px 0 20px; */
}
#details .main .content .pro-list span {
  line-height: 30px;
  color: #616161;
}
#details .main .content .pro-list .pro-price {
  float: right;
}
#details .main .content .pro-list .pro-price .pro-del {
  margin-left: 10px;
  text-decoration: line-through;
}
#details .main .content .pro-list .price-sum {
  color: #ff6700;
  font-size: 24px;
  /* padding-top: 20px; */
}
#details .main .content .button {
  height: 55px;
  margin: 10px 0 20px 0;
}
#details .main .content .button .el-button {
  float: left;
  height: 55px;
  font-size: 16px;
  color: #fff;
  border: none;
  text-align: center;
}
#details .main .content .button .shop-cart {
  width: 340px;
  background-color: #ff6700;
}
#details .main .content .button .shop-cart:hover {
  background-color: #f25807;
}

#details .main .content .button .like {
  width: 260px;
  margin-left: 40px;
  background-color: #b0b0b0;
}
#details .main .content .button .like:hover {
  background-color: #757575;
}
#details .main .content .pro-policy li {
  float: left;
  margin-right: 20px;
  color: #b0b0b0;
}
.aaa{
  background: #eee;
}
/* 主要内容CSS END */
</style>